import { render } from "./Congrats.vue?vue&type=template&id=5e52cbce&scoped=true"
const script = {}

import "./Congrats.vue?vue&type=style&index=0&id=5e52cbce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e52cbce"]])

export default __exports__